import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import gameActions from 'redux/actions/gameActions'
import pickerSelector from 'redux/selectors/picker/picker_selector'
import Modalizer from 'components/modalizer/modalizer'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import NearpodPicker from 'components/nearpod_picker/nearpod_picker'

class GameAnswerImagePicker extends PureComponent {

	constructor() {
		super()
		this.onFilePicked = this.onFilePicked.bind(this)
		this.onFileError = this.onFileError.bind(this)
	}

	onFilePicked(file) {
		this.props.actions.filePicked(this.acceptedFiles(), file, this.props.questionId, this.props.answerId)
	}

	onFileError() {
		this.props.actions.fileError(this.props.questionId, this.props.answerId)
	}

	acceptedFiles() {
		return ['image']
	}

	render() {
		return (
			<Modalizer width='570px' height={'564px'} nopadding={true} closeAction={this.props.actions.closeModal}>
				<NearpodPicker
					onFilesPicked={this.onFilePicked}
					closeHandler={this.props.actions.closeModal}
					pickerType={'image'}
					accept={this.acceptedFiles()}
					multiselect={false}
					onFileError={this.onFileError}
					googleDrivePickerOrigin={this.props.googleDrivePickerOrigin}
				/>
			</Modalizer>
		)
	}
}

GameAnswerImagePicker.propTypes = {
	modalName: PropTypes.string,
}

function mapStateToProps(state) {
	return pickerSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: gameActions.answerMediaPickerCancelled,
		filePicked: gameActions.answerMediaPickerSelected,
		fileError: gameActions.answerMediaPickerFailed,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(GameAnswerImagePicker)

export { GameAnswerImagePicker }
